import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TemplePage from './Pages/TemplePage';
import regalImage from './assets/Regal.png';
import Header from './Components/Header';
import Calendar from './Pages/CalendarPage';
import EventPage from './Pages/EventPage';
import GalleryPage from './Pages/GalleryPage';
function App() {
  return (
    <Router>
      <div className="App">
        <div
          className=" bg-[#FFEAD5] h-auto bg-center flex flex-col"
          style={{ backgroundImage: `url(${regalImage})` }}
        >
          <div
            className="bg-[#FFEAD5] fixed top-0 left-0 w-full z-50"
            style={{ backgroundImage: `url(${regalImage})` }}
          >
            <Header />
          </div>
          <div className="mt-24 ">
            <Routes>
              <Route path="/" element={<TemplePage />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/events" element={<EventPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
